package com.milta.core.localization.translations.bg

import com.milta.core.localization.TeamStrings

internal val Team = TeamStrings(
    screenTitle = "Екип",
    statusActive = "Активна",
    errorGeneric = "Възникна грешка. Моля, опитайте отново.",
    monthNames = listOf("януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септември", "октомври", "ноември", "декември"),
    enterpriseSectionLabel = "Шофьори в екипа",
    enterpriseEmptyHint = "Все още нямате шофьори в екипа си.",
    noEnterpriseFound = "Няма фирма, свързана с вашия акаунт.",
    columnHeaderDriver = "Шофьор",
    columnHeaderStatus = "Статус",
    columnHeaderActions = "Действия",
    addDriverSectionTitle = "Добавяне на шофьор",
    addDriverCodePlaceholder = "Код Milta — напр. MTA-28371",
    addDriverButton = "Добави този шофьор",
    addDriverErrorInvalidCode = "Моля, въведете валиден код.",
    addDriverErrorNotFound = "Невалиден или вече използван код.",
    addDriverErrorAlreadyMember = "Този шофьор вече е част от вашия екип.",
    addDriverErrorLinkedAccountIsEnterprise = "Този акаунт е фирма и не може да бъде добавен като шофьор.",
    addDriverErrorLimitReached = "Достигнат лимит: една фирма не може да има повече от 10 членове, включително вас. Премахнете шофьор, за да добавите друг.",
    addDriverErrorEnterpriseSubscriptionInactive = "Абонаментът на вашата фирма е изтекъл: подновете го, за да добавите шофьор.",
    driverDetailTitle = "Данни за шофьора",
    driverDetailPhoneLabel = "Телефон",
    removeDriverButton = "Премахни",
    removeDriverDialogTitle = "Премахване на този шофьор?",
    removeDriverDialogMessagePrefix = "На път сте да премахнете",
    removeDriverDialogMessageSuffix = "от вашия екип. Неговият/нейният акаунт в Milta ще остане активен.",
    removeDriverErrorNotFound = "Шофьорът не е намерен.",
    removeDriverErrorOnActiveDelivery = "Този шофьор в момента извършва доставка и не може да бъде премахнат.",
    removeDriverErrorLastOwner = "Вие сте единственият администратор на тази компания. Добавете друг фирмен акаунт, преди да се оттеглите от екипа.",
)
